import { Context, ReactNode, createContext, useContext } from "react";

export enum UploadStatus {
  // transfer upload not initiated
  idle = "idle",
  ongoing = "ongoing",
  // internet outtage
  paused = "paused",
  failed = "failed",
  success = "success",
  aborted = "aborted",
}

const UploadStatusContext: Context<UploadStatus> = createContext<UploadStatus>(
  UploadStatus.idle
);

const useUploadStatus = (): UploadStatus => useContext(UploadStatusContext);

type UploadStatusProviderProp = {
  children: ReactNode;
  uploadStatus: UploadStatus;
};
/**
 * Provider wrapper which provides status of transfer uplaod
 * down the component tree.
 *
 * @param UploadStatusProviderProp
 * @returns transfer upload status provider wrapper component.
 */
const UploadStatusProvider = ({
  children,
  uploadStatus,
}: UploadStatusProviderProp): JSX.Element => {
  return (
    <UploadStatusContext.Provider value={uploadStatus}>
      {children}
    </UploadStatusContext.Provider>
  );
};

export { useUploadStatus, UploadStatusProvider };
